import { MutableRefObject, useCallback, useEffect, useState } from 'react'

const useKeyboardNavigation =(ref:MutableRefObject<any>) => {
  const [isKeyboardFocused, setKeyboardFocused] = useState(false)

  const upHandler = useCallback((event: KeyboardEvent)=> {
    if (event.key === 'Tab' && event.target === ref.current) {
      setKeyboardFocused(true)
    }
  },[ref])

  const focusOutHandler = useCallback(() => {
    setKeyboardFocused(false)
  },[])

  useEffect(() => {
    window.addEventListener('keyup', upHandler)
    window.addEventListener('focusout', focusOutHandler)

    return () => {
      window.removeEventListener('keyup', upHandler)
      window.removeEventListener('focusout', focusOutHandler)
    }
  }, [focusOutHandler, upHandler])

  return isKeyboardFocused
}

export default useKeyboardNavigation
